module.exports = __webpack_public_path__ + "img/icon-teacher.9f07cde2.svg";